import { localStorage, api } from '@comall-backend-builder/core/lib/services';
import { getStore } from '@comall-backend-builder/core/lib/store';
import { actions } from '@comall-backend-builder/core';
import { errorHandle } from './error-handle';

export const logout = () => {
    api.delete({}, { apiPath: '/logout', apiRoot: ENV.API_ROOT }).then(() => {
        localStorage.remove('user');
        window.location.href = ENV.REDIRECT_URI + '/#/login';

        getStore().dispatch(actions.logoutSuccessAction());
    }).catch(errorHandle);
}